import { render, staticRenderFns } from "./RenterTable.vue?vue&type=template&id=048821c0"
import script from "./RenterTable.vue?vue&type=script&lang=js"
export * from "./RenterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports